/** Returns a contrast colour (#fff or #000) readable against the given hex background */
export function contrastColour(hex: string): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  // Relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
}

/** Format minutes into "Xh Ym" */
export function formatMinutes(mins: number): string {
  if (mins === 0) return '0m';
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
}

/** Format ISO date string to readable */
export function formatDate(iso: string): string {
  return new Date(iso).toLocaleString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

/** Calculate price range for a class from a vehicle list */
export function classPriceRange(prices: (number | null)[]): string | null {
  const valid = prices.filter((p): p is number => p !== null && p > 0);
  if (valid.length === 0) return null;
  const min = Math.min(...valid);
  const max = Math.max(...valid);
  if (min === max) return `£${min.toLocaleString()}`;
  return `£${min.toLocaleString()} – £${max.toLocaleString()}`;
}

/** Image URL from R2 key */
export function imageUrl(key: string | null): string | null {
  if (!key) return null;
  return `/api/images/${encodeURIComponent(key)}`;
}

/** Resolved display URL for a vehicle — prefers R2 key over external URL */
export function vehicleImageSrc(v: { image_key?: string | null; image_url?: string | null }): string | null {
  if (v.image_key) return `/api/images/${encodeURIComponent(v.image_key)}`;
  if (v.image_url) return v.image_url;
  return null;
}

/** Darken a hex colour by a percentage */
export function darken(hex: string, pct: number): string {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - Math.round(255 * pct / 100));
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - Math.round(255 * pct / 100));
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - Math.round(255 * pct / 100));
  return `#${r.toString(16).padStart(2,'0')}${g.toString(16).padStart(2,'0')}${b.toString(16).padStart(2,'0')}`;
}
